import { ExternalLinkIcon } from "@chakra-ui/icons";
import {
  Link, Tooltip, Text, TextProps, LinkProps,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router";

interface ExternalLinkProps extends TextProps {
  to: string;
  text: string;
  includeTooltip?: boolean;
  linkProps?: Record<string, unknown>;
}

export default function ExternalLink({
  to, text, linkProps = {}, includeTooltip = false, ...rest
}: ExternalLinkProps) {
  const content = (
    <Text {...rest}>
      <Link href={to} isExternal _hover={{ textDecoration: "none" }} {...linkProps}>
        {text}
        {" "}
        <ExternalLinkIcon mb="4px" ml="4px" />
      </Link>
    </Text>
  );

  return includeTooltip ? (
    <Tooltip label={to} placement="top">
      {content}
    </Tooltip>
  ) : (
    content
  );
}

interface ExternalLinkButtonProps {
  to: string;
  label: string;
  linkProps?: Record<string, unknown>;
}

export function ExternalLinkButton({ label, to, linkProps = {} }: ExternalLinkButtonProps) {
  return (
    <Tooltip label={label} placement="top">
      <Link href={to} _hover={{ textDecoration: "none" }} isExternal {...linkProps}>
        <ExternalLinkIcon mb="4px" ml="4px" />
      </Link>
    </Tooltip>
  );
}

interface InternalLinkProps extends LinkProps {
  to: string;
  newTab?: boolean;
}

export function InternalLink({ to, newTab = false, children, ...rest }: InternalLinkProps) {
  return (
    <Link
      as={RouterLink}
      to={to}
      isExternal={newTab}
      _hover={{ textDecoration: "none" }}
      {...rest}
    >
      {children}
    </Link>
  );
}
